import React from "react";

export default function FallbackView() {
  return <div>User not found...</div>;
}
